<template>
  <div class="container-fluid">
    <div class="div-title">Сборки в работе</div>

    <div v-if="loading" class="text-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Загрузка...</span>
      </div>
    </div>

    <div v-else-if="error" class="alert alert-danger mt-3">
      {{ error }}
    </div>

    <div v-else-if="assemblies.length === 0" class="alert alert-info mt-3">
      Нет активных сборок
    </div>

    <div v-else class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-primary">
          <tr>
            <th>Дата</th>
            <th>Наименование</th>
            <th>Роликов</th>
            <th>Вес (кг)</th>
            <th>Примечание</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="assembly in assemblies"
            :key="assembly.name"
            @click="openAssemblyDetails(assembly)"
            class="clickable-row"
          >
            <td>{{ assembly.date }}</td>
            <td>{{ assembly.name }}</td>
            <td>{{ assembly.count }}</td>
            <td>{{ assembly.kg }}</td>
            <td>{{ assembly.comm || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal for assembly details -->
    <div
      class="modal fade"
      id="assemblyDetailsModal"
      tabindex="-1"
      aria-hidden="true"
      @hidden="onModalHidden"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Состав сборки: {{ selectedAssembly?.name || "" }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="selectedAssembly" class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>№</th>
                    <th colspan="3">Ролик</th>
                    <th>Место</th>
                    <th>Кг</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="roll in selectedAssembly.rolls" :key="roll.num">
                    <td>{{ roll.num }}</td>
                    <td>{{ roll.name }}</td>
                    <td>{{ roll.format }}</td>
                    <td>{{ roll.gr }}</td>
                    <td>{{ roll.place }}</td>
                    <td>{{ roll.kg }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { fetchAssemblies } from "../api.js";
import { Modal } from "bootstrap";

export default {
  data() {
    return {
      loading: false,
      error: null,
      assemblies: [],
      selectedAssembly: null,
      modal: null,
      isModalOpen: false,
    };
  },

  async created() {
    await this.loadAssemblies();
  },

  methods: {
    onModalHidden() {
      this.isModalOpen = false;
      // Удаляем состояние из истории, если оно было добавлено
      if (window.history.state?.modalOpen) {
        window.history.replaceState({}, "");
      }
    },

    async loadAssemblies() {
      this.loading = true;
      this.error = null;

      try {
        const skladnum = this.$store.state.skladNum;
        const response = await fetchAssemblies(skladnum);

        if (response.data && Array.isArray(response.data.assemblies)) {
          this.assemblies = response.data.assemblies;
        } else {
          this.assemblies = [];
        }
      } catch (err) {
        this.error = err.response?.statusText || "Не удалось загрузить данные";
        console.error("Ошибка при загрузке сборок:", err);
      } finally {
        this.loading = false;
      }
    },

    openAssemblyDetails(assembly) {
      this.selectedAssembly = assembly;
      if (!this.modal) {
        this.modal = new Modal(document.getElementById("assemblyDetailsModal"));

        // Обработчик события скрытия модального окна
        this.modal._element.addEventListener("hidden.bs.modal", () => {
          this.onModalHidden();
        });
      }

      this.modal.show();
      this.isModalOpen = true;
      // Добавляем состояние в историю только если его еще нет
      if (!window.history.state?.modalOpen) {
        window.history.pushState({ modalOpen: true }, "");
      }
    },

    handlePopState(event) {
      if (this.isModalOpen) {
        // Если модальное окно открыто, закрываем его
        this.modal.hide();
        // Предотвращаем стандартное поведение навигации
        event.preventDefault();
        // Возвращаем состояние в истории
        window.history.go(1);
      }
    },
  },

  mounted() {
    window.addEventListener("popstate", this.handlePopState);
  },

  beforeUnmount() {
    window.removeEventListener("popstate", this.handlePopState);
    // Убедимся, что модальное окно закрыто при размонтировании компонента
    if (this.modal) {
      this.modal.hide();
    }
  },
};
</script>

<style scoped>
.div-title {
  font-size: large;
  padding: 10px;
  background-color: darkseagreen;
  margin-bottom: 15px;
  font-weight: bold;
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #f8f9fa !important;
}

.table-responsive {
  overflow-x: auto;
}

/* Для мобильных устройств */
@media (max-width: 768px) {
  .modal-dialog {
    margin: 0.5rem;
    width: auto;
  }

  table {
    font-size: 0.9rem;
  }

  th,
  td {
    padding: 0.5rem;
  }
}
</style>